var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 12.668H5.33268C4.0756 12.668 3.44707 12.668 3.05654 13.0585C2.66602 13.449 2.66602 14.0776 2.66602 15.3346V26.668C2.66602 27.925 2.66602 28.5536 3.05654 28.9441C3.44707 29.3346 4.0756 29.3346 5.33268 29.3346H5.99935C7.25643 29.3346 7.88496 29.3346 8.2755 28.9441C8.66602 28.5536 8.66602 27.925 8.66602 26.668V15.3346C8.66602 14.0776 8.66602 13.449 8.2755 13.0585C7.88496 12.668 7.25643 12.668 5.99935 12.668Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 5.66797C8.66602 7.32482 7.32287 8.66797 5.66602 8.66797C4.00916 8.66797 2.66602 7.32482 2.66602 5.66797C2.66602 4.01112 4.00916 2.66797 5.66602 2.66797C7.32287 2.66797 8.66602 4.01112 8.66602 5.66797Z",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.434 12.668H15.3327C14.0756 12.668 13.4471 12.668 13.0565 13.0585C12.666 13.449 12.666 14.0776 12.666 15.3346V26.668C12.666 27.925 12.666 28.5536 13.0565 28.9441C13.4471 29.3346 14.0756 29.3346 15.3327 29.3346H15.9993C17.2564 29.3346 17.8849 29.3346 18.2755 28.9441C18.666 28.5536 18.666 27.925 18.666 26.668L18.6661 22.0014C18.6661 19.7924 19.3701 18.0014 21.4499 18.0014C22.4896 18.0014 23.3327 18.8969 23.3327 20.0014V26.0014C23.3327 27.2585 23.3327 27.887 23.7232 28.2776C24.1136 28.6681 24.7423 28.6681 25.9993 28.6681H26.6643C27.9211 28.6681 28.5495 28.6681 28.94 28.2777C29.3305 27.8873 29.3307 27.2589 29.3309 26.0021L29.3328 18.6682C29.3328 15.3546 26.1812 12.6683 23.0618 12.6683C21.2859 12.6683 19.7016 13.5388 18.6661 14.9C18.666 14.0598 18.666 13.6398 18.4836 13.328C18.368 13.1304 18.2035 12.966 18.006 12.8505C17.6941 12.668 17.2741 12.668 16.434 12.668Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.39ccee5214459f4e65bacf3b7b67ec97.svg";
export { ForwardRef as ReactComponent };